import {
  Step,
  StepConnector,
  StepConnectorProps,
  StepIconProps,
  StepLabel,
  Stepper,
  Typography,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { CameraAltOutlined, PersonOutline } from '@mui/icons-material';
import { ReactComponent as CardSVG } from '../assets/card.svg';
import React from 'react';
import { AddInsuranceView } from '../Settings/types';


export type AddInsuranceStepperType = {
  steps: {
    label: string;
    value: AddInsuranceView;
  }[];
  currentStep: string;
  isMobile?: boolean;
};

export const AddInsuranceStepper: React.VFC<AddInsuranceStepperType> = ({ steps, currentStep, isMobile = false }) => {
  const { classes } = useStyles();

  const activeStepIndex = steps.findIndex(({ value }) => value === currentStep);
  const activeStep = activeStepIndex !== -1 ? activeStepIndex : 1;

  return (
    <Stepper alternativeLabel connector={<StepperConnector isMobile={isMobile} />} activeStep={activeStep} className={classes.stepper}>
      {steps.map(({ label, value }) => (
        <Step key={label}>
          <StepLabel
            StepIconComponent={(props) => <StepIcon {...props} iconKey={value} isMobile={isMobile} />}
          >
            {!isMobile && <Typography color="inherit" variant="caption">{label}</Typography>}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

const useStyles = makeStyles()({
  stepper: {
    padding: 0,
  },
});

export type StepIconType = {
  isMobile?: boolean;
  iconKey: AddInsuranceView;
} & StepIconProps;

const icons: Partial<Record<AddInsuranceView, React.ReactNode>> = {
  [AddInsuranceView.details]: <CardSVG />,
  [AddInsuranceView.card]: <CameraAltOutlined />,
  [AddInsuranceView.primarySubscriber]: <PersonOutline />
};

const StepIcon: React.VFC<StepIconType> = ({ isMobile, ...props }) => {
  const { classes, cx } = useStepIconStyles({ isMobile });
  const { active, completed, iconKey } = props;

  return (
    (
      <div className={cx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
      >
        {icons[iconKey]}
      </div>
    )
  );
};

type StepperStylesProps = { isMobile: boolean | undefined};
const useStepIconStyles = makeStyles<StepperStylesProps>()((theme, { isMobile }) => ({
  root: {
    width: theme.spacing(!isMobile ? 7 : 5),
    height: theme.spacing(!isMobile ? 7 : 5),
    background: 'transparent',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.palette.text.secondary}`,
    color: theme.palette.text.secondary,
  },
  active: {
    background: theme.palette.secondary.background,
    border: `1.5px solid ${theme.palette.secondary.border}`,
    color: theme.palette.secondary.main
  },
  completed: {
    background: theme.palette.secondary.background,
    border: `1px solid ${theme.palette.secondary.border}`,
    color: theme.palette.secondary.main
  }
}));

type StepperConnectorType = {
  isMobile?: boolean;
} & StepConnectorProps;
const StepperConnector: React.VFC<StepperConnectorType> = ({ isMobile, ...props }) => {
  const { classes } = useStepperConnectorStyles({ isMobile });

  return <StepConnector classes={classes} {...props} />;
};

const useStepperConnectorStyles = makeStyles<StepperStylesProps, 'line'>()((theme, { isMobile }, classes) => ({
  alternativeLabel: {
    top: theme.spacing(!isMobile ? 3.5 : 2.5),
    marginLeft: theme.spacing(!isMobile ? 2 : 1),
    marginRight: theme.spacing(!isMobile ? 2 : 1),
  },
  active: {
    [`& .${classes.line}`]: {
      background: theme.palette.secondary.border,
    },
  },
  completed: {
    [`& .${classes.line}`]: {
      background: theme.palette.secondary.border,
    },
  },
  line: {
    height: 1,
    border: 0,
    background: theme.palette.text.secondary,
  }
}));
